/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ClientEmployeeActivityFragment = { __typename: 'ClientEmployeeType', id: string, email: string, name: string, resourceGroupCount: number };

export type ClientEmployeesByActivityQueryVariables = Types.Exact<{
  clientId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  sortBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ClientEmployeesByActivityQuery = { __typename: 'Query', clientEmployees?: { __typename: 'ClientEmployeeTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'ClientEmployeeTypeEdge', node?: { __typename: 'ClientEmployeeType', id: string, email: string, name: string, resourceGroupCount: number } | null } | null>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const ClientEmployeeActivityFragmentDoc = new TypedDocumentString(`
    fragment ClientEmployeeActivity on ClientEmployeeType {
  id
  email
  name
  resourceGroupCount
}
    `, {"fragmentName":"ClientEmployeeActivity"});
export const ClientEmployeesByActivityDocument = new TypedDocumentString(`
    query ClientEmployeesByActivity($clientId: UUID, $sortBy: String, $first: Int) {
  clientEmployees(clientId: $clientId, sortBy: $sortBy, first: $first) {
    edges {
      node {
        ...ClientEmployeeActivity
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
  }
}
    fragment ClientEmployeeActivity on ClientEmployeeType {
  id
  email
  name
  resourceGroupCount
}`);

export const useClientEmployeesByActivityQuery = <
      TData = ClientEmployeesByActivityQuery,
      TError = unknown
    >(
      variables?: ClientEmployeesByActivityQueryVariables,
      options?: Omit<UseQueryOptions<ClientEmployeesByActivityQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientEmployeesByActivityQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientEmployeesByActivityQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ClientEmployeesByActivity'] : ['ClientEmployeesByActivity', variables],
    queryFn: fetcher<ClientEmployeesByActivityQuery, ClientEmployeesByActivityQueryVariables>(ClientEmployeesByActivityDocument, variables),
    ...options
  }
    )};

useClientEmployeesByActivityQuery.getKey = (variables?: ClientEmployeesByActivityQueryVariables) => variables === undefined ? ['ClientEmployeesByActivity'] : ['ClientEmployeesByActivity', variables];

export const useInfiniteClientEmployeesByActivityQuery = <
      TData = InfiniteData<ClientEmployeesByActivityQuery>,
      TError = unknown
    >(
      variables: ClientEmployeesByActivityQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientEmployeesByActivityQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientEmployeesByActivityQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientEmployeesByActivityQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['ClientEmployeesByActivity.infinite'] : ['ClientEmployeesByActivity.infinite', variables],
      queryFn: (metaData) => fetcher<ClientEmployeesByActivityQuery, ClientEmployeesByActivityQueryVariables>(ClientEmployeesByActivityDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientEmployeesByActivityQuery.getKey = (variables?: ClientEmployeesByActivityQueryVariables) => variables === undefined ? ['ClientEmployeesByActivity.infinite'] : ['ClientEmployeesByActivity.infinite', variables];


useClientEmployeesByActivityQuery.fetcher = (variables?: ClientEmployeesByActivityQueryVariables) => fetcher<ClientEmployeesByActivityQuery, ClientEmployeesByActivityQueryVariables>(ClientEmployeesByActivityDocument, variables);
